import TInput from './input.vue'

TInput.install = Vue => {
  Vue.component(TInput.name, TInput)
}

export default TInput



// WEBPACK FOOTER //
// ./src/module/input/index.js